(() => {
    window.addEventListener("DOMContentLoaded", () => {
        if (!document.querySelector('.businessrangeslider__range')) {
            return
        }

        document.querySelector('.businessrangeslider__range').addEventListener('input', () => {
            let count = parseInt(document.querySelector('.businessrangeslider__range').value)

            if (count > 620) {
                document.querySelector('.businessrangeslider__count').innerHTML = (document.querySelector('html').getAttribute('lang') == 'de-de') ? 'Mehr als 620' : 'More than 620'

                return
            }

            if (count <= 20) {
                document.querySelector('.businessrangeslider__count').innerHTML = (document.querySelector('html').getAttribute('lang') == 'de-de') ? '1 - 20' : '1 - 20'

                return
            }

            document.querySelector('.businessrangeslider__count').innerHTML = count
        })

        if (!document.querySelector('.businessrangeslider button')) {
            return
        }

        document.querySelector('.businessrangeslider button').addEventListener('click', () => {
            let parcelCount = parseInt(document.querySelector('.businessrangeslider__range').value)
            let baselink = (document.querySelector('html').getAttribute('lang') === 'de-de') ? '/geschaeftlich-versenden/geschaeftskunde-werden' : '/en/business-shipping/become-a-business-customer'

            if (parcelCount <= 20) {
                new BSN.Modal('#modal_businessrangeslider__glsonedialog').show()
            } else if (parcelCount <= 300) {
                window.location = baselink + '-v01#parcelcount=' + parcelCount
            } else if (parcelCount <= 620) {
                window.location = baselink + '-v02#parcelcount=' + parcelCount
            } else {
                window.location = baselink + '-v03#parcelcount=' + parcelCount
            }
        })
    });
}) ()